var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.screen > 434)?_c('home-pc'):_vm._e(),(_vm.screen > 0 && _vm.screen <= 434)?_c('home-mobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }